import { getDocuments } from '../services/documents';

const getFirmwareUpdateHistory = async ({
  fromDate,
  toDate,
  searchInput,
  tenantPk,
  page,
  size,
}: {
  fromDate?: string;
  toDate?: string;
  searchInput?: string;
  tenantPk?: string | number;
  page?: number;
  size?: number;
}): Promise<any> => {
  const params = new URLSearchParams();
  if (fromDate) params.append('fromDate', fromDate);
  if (toDate) params.append('toDate', toDate);
  if (searchInput) params.append('searchInput', searchInput);
  if (tenantPk) params.append('tenantPk', String(tenantPk));
  if (page != null) params.append('page', String(page));
  if (size != null) params.append('size', String(size));

  return getDocuments(`firmware-update-history?${params.toString()}`);
};

export { getFirmwareUpdateHistory };
